<template>
    <!-- Filter leads -->
    <CContainer fluid>
        <CRow
            alignHorizontal="end"
        >
            <div class="position-relative">
                <CBadge color="secondary" class="badge--round badge--absolute" v-if="countFiltersActive()">{{ countFiltersActive() }}</CBadge>
                <CDropdown
                    color="secondary"
                    class="mb-3"
                >
                    <template #toggler>
                        <CButton>
                            <CIcon :content="$options.icons.cilListFilter" />
                        </CButton>
                    </template>
                    <CDropdownItem
                        v-for="(item) in fieldsComponent"
                        :key="item.key"
                        @click="selectFilter(item.key)"
                        :class="[
                            (checkFilterActive(item.key))? 'shadow':'',
                            (!checkFilterVisible(item.key))? 'd-none':'',
                        ]"
                    >
                        <div class="form-check">
                            <input 
                                type="checkbox" 
                                class="form-check-input" 
                                :id="item.key"
                                v-model="item._filter.active"
                                @click="toggleFiledFilterActive"
                            >
                            <label class="form-check-label" :for="item.key">{{ $t(item.label) }}</label>
                        </div>
                    </CDropdownItem>
                    <div class=" text-center">
                        <CButton
                                color="primary"
                                @click="activeFiltersSelects()"
                            >
                                {{ $t('Filter')}}
                        </CButton>
                    </div>
                </CDropdown>
            </div>
            
        </CRow>
        <CRow v-if="fieldFilterSelected != null && fieldFilterSelected._filter.active">
            <CCol sm="12">
                <CSelect
                    v-if="fieldFilterSelected._filter.type == 'select'"
                    :options="fieldFilterSelected._filter.options"
                    :isValid="checkIfFilterIsValid()"
                    :value.sync="$v.fieldFilterSelected._filter.value.$model"
                    :placeholder="filterPlaceholder"
                >
                    <template #prepend>
                        <CDropdown
                            :togglerText="$t(fieldFilterSelected._filter.condition)"
                        >
                            <CDropdownItem
                            >
                                {{ $t(fieldFilterSelected._filter.condition) }}
                            </CDropdownItem>
                        </CDropdown>
                    </template>
                    <template #append>
                        <CButton
                            @click="runFilter()"
                        >
                            {{ $t('ready')}}
                        </CButton>
                    </template>

                </CSelect>
                <CInput
                    v-else
                    class="input-filter"
                    :isValid="checkIfFilterIsValid()"
                    :value.sync="$v.fieldFilterSelected._filter.value.$model"
                    :placeholder="filterPlaceholder"
                    @keyup.enter="runFilter()"
                >
                    <template #prepend>
                        <CDropdown
                            :togglerText="$t(fieldFilterSelected._filter.condition)"
                        >
                            <CDropdownItem
                                v-for="(item) in conditions"
                                :key="item.key"
                                @click="fieldFilterSelected._filter.condition = item"
                            >
                                {{ $t(item) }}
                            </CDropdownItem>
                        </CDropdown>
                    </template>
                    <template #append>
                        <CButton
                            @click="runFilter()"
                        >
                            {{ $t('ready')}}
                        </CButton>
                    </template>
                </CInput>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>

import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import { cilFilter,cilListFilter } from '@coreui/icons';
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
export default {
    name: "FilterFieldsComponent",
    icons:{
        cilFilter,
        cilListFilter
    },
    components:{
        Calendar,
        DatePicker
    },
    mixins: [validationMixin],
    data(){
        return {
            fieldsComponent: [],
            fieldFilterSelected:null,
            conditions:[
                'contains',
                'not_contains',
                'is_equal_to',
                'is_not_equal_to',
                'is_in_list',
                'not_in_list',
                /* 'is_not_equal_to',
                'not_contains',
                'start_by',
                'not_start_by' */
            ]
        }
    },
    validations:{
        fieldFilterSelected:{
            _filter:{
                value: {
                    required
                }
            }
        }
    },
    computed:{
        filterPlaceholder: function(){
            let placeholder = this.$t('select_a_field');
            let label;
            if(this.fieldFilterSelected)
                label = this.fieldFilterSelected.label;
            if(label){
                placeholder = this.$t('filter_the') + ' ' + label;
            }
            return placeholder;
        },
    },
    props:{
        fields:{
            default:undefined
        },
        filters:{
            default:undefined
        }
    },

    methods:{
        checkIfFilterIsValid(){
            const field = this.$v.fieldFilterSelected;
            if (!field.$dirty) {
                return null
            } 
            return !(field.$invalid || field.$model === '')
        },
        checkFilterActive(fieldKey){
            let field = this.getField(fieldKey);
            if(field && field._filter && field._filter.active){
                return field._filter.active;
            }
            return false;
        },
        checkFilterVisible(fieldKey){
            let field = this.getField(fieldKey);
            return field._filter !== false;
        },
        getField(fieldKey){
            let findIndex = this.fieldsComponent.findIndex(field => field.key === fieldKey);
            if(findIndex === -1){
                throw new Error("Field not found");
            }
            return this.fieldsComponent[findIndex];
        },
        setField(fieldKey, value) {
            let findIndex = this.fieldsComponent.findIndex(field => field.key === fieldKey);
            if(findIndex === -1){
                throw new Error("Field not found");
            }
            this.fieldsComponent[findIndex] = value;
        },
        activeFiltersSelects(){
                this.$emit('filter', this.fieldsComponent);
                this.$emit('update:fields', this.fieldsComponent);
                this.runFilter();
        },
        selectFilter(fieldKey, who="input"){
            let fieldSelected = this.getField(fieldKey);

            if( who == "checkbox" && !fieldSelected._filter.active == false){
                fieldSelected._filter.active= false;
            }else{
                fieldSelected._filter.active= true;
            }

            fieldSelected = this.formatFieldToFilter(fieldSelected);
            this.setField(fieldKey, fieldSelected);
            this.fieldFilterSelected = fieldSelected;

            this.$v.$reset();
        },

        toggleFiledFilterActive(event){
            event.stopPropagation();
            let option = event.target.id;
            this.selectFilter(option, "checkbox");
        },
        countFiltersActive(){
            let fieldFilters = this.fieldsComponent.filter( field => field._filter  && (typeof field._filter === 'object') && !Array.isArray(field._filter) && field._filter.active );
            return fieldFilters.length;
        },
        checkFieldFilterIsValid(field){
            return field._filter  && (typeof field._filter === 'object') && !Array.isArray(field._filter)
        },

        formatFieldToFilter(field){
            let fieldFormat = field;
            
            if(!this.checkFieldFilterIsValid(fieldFormat) && fieldFormat._filter !== false){
                fieldFormat._filter = {
                    active:false,
                    value:null,
                    placeholder:"filter",
                    condition:this.conditions[0],
                    type:'text',
                    expressionType:"filter"
                }
            }
            return fieldFormat;
        },

        formatFieldsToFilter(fields){
            let fieldsFormat = fields;
            return fieldsFormat.map(field => {
                if(field._filter === true){
                    field = this.formatFieldToFilter(field);
                }
                return field;
            });
        },
        resetFilterSelected(){
            this.fieldFilterSelected = null
            this.$v.$reset();
        },
        runFilter(){
            let valFieldFilterSelected = this.$v.fieldFilterSelected;
            valFieldFilterSelected.$touch();
            if(valFieldFilterSelected.$invalid){
                return;
            }
            this.setField(this.fieldFilterSelected.key,this.fieldFilterSelected);
            this.$emit('filter', this.fieldsComponent);
            this.$emit('update:fields', this.fieldsComponent);
            this.resetFilterSelected();
        }
    },
    mounted(){
        this.fieldsComponent = this.formatFieldsToFilter(this.fields);
        // this.fieldsComponent = [...this.fields];
    }
    
}
</script>

<style lang="scss" scoped>
    input{
        height: auto !important;
    }
    .input-filter{
            & input{
                position: relative;
                & ::placeholder{
                color:blue;
                position: absolute;
                top: 0;
            }
        }
    }

</style>